// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/mutation-create-board.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks_New_Content_Board(
  $stages: jsonb!
  $metadata: jsonb!
  $type: tasks_board_types_enum!
  $name: String!
) {
  tasks_create_board_and_stages(
    name: $name
    type: $type
    metadata: $metadata
    stages: $stages
  ) {
    id
  }
}

`